const SYMBOLS = {
    /*
    0x00: 'GOWARM',
    0x03: 'GOSTROUT',
    0x0A: 'USR',
    0x0D: 'CHARAC',
    0x0E: 'ENDCHR',
    0x0F: 'TKN.CNTR',
    0x0F: 'EOL.PNTR',
    0x0F: 'NUMDIM',
    0x10: 'DIMFLG',
    0x11: 'VALTYP',
    0x13: 'DATAFLG',
    0x13: 'GARFLG',
    0x14: 'SUBFLG',
    0x15: 'INPUTFLG',
    0x16: 'CPRMASK',
    0x16: 'SIGNFLG',
    0x1A: 'HGR.SHAPE',
    0x1C: 'HGR.BITS',
    0x1D: 'HGR.COUNT',
    0x24: 'MON.CH',
    0x26: 'MON.GBASL',
    0x27: 'MON.GBASH',
    0x2C: 'MON.H2',
    0x2D: 'MON.V2',
    0x30: 'MON.HMASK',
    0x32: 'MON.INVFLG',
    0x33: 'MON.PROMPT',
    0x3C: 'MON.A1L',
    0x3D: 'MON.A1H',
    0x3E: 'MON.A2L',
    0x3F: 'MON.A2H',
    0x50: 'LINNUM',
    0x52: 'TEMPPT',
    0x53: 'LASTPT',
    0x55: 'TEMPST',
    0x5E: 'INDEX',
    0x60: 'DEST',
    0x62: 'RESULT',
    0x67: 'TXTTAB',
    0x69: 'VARTAB',
    0x6B: 'ARYTAB',
    0x6D: 'STREND',
    0x6F: 'FRETOP',
    0x71: 'FRESPC',
    0x73: 'MEMSIZ',
    0x75: 'CURLIN',
    0x77: 'OLDLIN',
    0x79: 'OLDTEXT',
    0x7B: 'DATLIN',
    0x7D: 'DATPTR',
    0x7F: 'INPTR',
    0x81: 'VARNAM',
    0x83: 'VARPNT',
    0x85: 'FORPNT',
    0x87: 'TXPSV',
    0x87: 'LASTOP',
    0x89: 'CPRTYP',
    0x8A: 'TEMP3',
    0x8A: 'FNCNAM',
    0x8C: 'DSCPTR',
    0x8F: 'DSCLEN',
    0x90: 'JMPADRS',
    0x91: 'LENGTH',
    0x92: 'ARG.EXTENSION',
    0x93: 'TEMP1',
    0x94: 'ARYPNT',
    0x94: 'HIGHDS',
    0x96: 'HIGHTR',
    0x98: 'TEMP2',
    0x99: 'TMPEXP',
    0x99: 'INDX',
    0x9A: 'EXPON',
    0x9B: 'DPFLG',
    0x9B: 'LOWTR',
    0x9C: 'EXPSGN',
    0x9D: 'FAC',
    0x9D: 'DSCTMP',
    0xA0: 'VPNT',
    0xA2: 'FAC.SIGN',
    0xA3: 'SERLEN',
    0xA4: 'SHIFT.SIGN.EXT',
    0xA5: 'ARG',
    0xAA: 'ARG.SIGN',
    0xAB: 'SGNCPR',
    0xAC: 'FAC.EXTENSION',
    0xAD: 'SERPNT',
    0xAB: 'STRNG1',
    0xAD: 'STRNG2',
    0xAF: 'PRGEND',
    0xB1: 'CHRGET',
    0xB7: 'CHRGOT',
    0xB8: 'TXTPTR',
    0xC9: 'RNDSEED',
    0xD0: 'HGR.DX',
    0xD2: 'HGR.DY',
    0xD3: 'HGR.QUADRANT',
    0xD4: 'HGR.E',
    0xD6: 'LOCK',
    0xD8: 'ERRFLG',
    0xDA: 'ERRLIN',
    0xDC: 'ERRPOS',
    0xDE: 'ERRNUM',
    0xDF: 'ERRSTK',
    0xE0: 'HGR.X',
    0xE2: 'HGR.Y',
    0xE4: 'HGR.COLOR',
    0xE5: 'HGR.HORIZ',
    0xE6: 'HGR.PAGE',
    0xE7: 'HGR.SCALE',
    0xE8: 'HGR.SHAPE.PNTR',
    0xEA: 'HGR.COLLISIONS',
    0xF0: 'FIRST',
    0xF1: 'SPEEDZ',
    0xF2: 'TRCFLG',
    0xF3: 'FLASH.BIT',
    0xF4: 'TXTPSV',
    0xF6: 'CURLSV',
    0xF8: 'REMSTK',
    0xF9: 'HGR.ROTATION',
    0x0100: 'STACK',
    0x0200: 'INPUT.BUFFER',
    0x03F5: 'AMPERSAND.VECTOR',
*/
    0xc000: 'KEYBOARD',
    0xc001: '80STOREON',
    0xc002: 'RAMRDOFF',
    0xc003: 'RAMRDON',
    0xc004: 'RAMWROFF',
    0xc005: 'RAMWRON',
    0xc006: 'INTCXOFF',
    0xc007: 'INTCXON',
    0xc008: 'ALTZPOFF',
    0xc009: 'ALTZPON',
    0xc00a: 'SLOT3OFF',
    0xc00b: 'SLOT3ON',
    0xc00c: 'CLR80VID',
    0xc00d: 'SET80VID',
    0xc00e: 'CLRALTCH',
    0xc00f: 'SETALTCH',
    0xc010: 'STROBE',
    0xc011: 'BSRBANK2',
    0xc012: 'BSRREAD',
    0xc013: 'RAMRD',
    0xc014: 'RAMWRT',
    0xc015: 'INTCXROM',
    0xc016: 'ALTZP',
    0xc017: 'SLOT3ROM',
    0xc018: '80STRORE',
    0xc019: 'VERTBLANK',
    0xc01a: 'RDTEXT',
    0xc01b: 'RDMIXED',
    0xc01c: 'RDPAGE2',
    0xc01d: 'RDHIRES',
    0xc01e: 'RDALTCH',
    0xc01f: 'RD80VID',
    0xc020: 'TAPEOUT',
    0xc030: 'SPEAKER',
    0xc050: 'CLRTEXT',
    0xc051: 'SETTEXT',
    0xc052: 'CLRMIXED',
    0xc053: 'SETMIXED',
    0xc054: 'PAGE1',
    0xc055: 'PAGE2',
    0xc056: 'CLRHIRS',
    0xc057: 'SETHIRES',
    0xc058: 'CLRAN0',
    0xc059: 'SETAN0',
    0xc05a: 'CLRAN1',
    0xc05b: 'SETAN1',
    0xc05c: 'CLRAN2',
    0xc05d: 'SETAN2',
    0xc05e: 'CLRAN3',
    0xc05f: 'SETAN3',
    0xc060: 'TAPEIN',
    0xc061: 'PB0',
    0xc062: 'PB1',
    0xc063: 'PB2',
    0xc064: 'PADDLE0',
    0xc065: 'PADDLE1',
    0xc066: 'PADDLE2',
    0xc067: 'PADDLE3',
    0xc070: 'PDLTRIG',
    0xc07e: 'SETIOUDIS',
    0xc07f: 'CLRIOUDIS',
    0xc080: 'RDBSR2',
    0xc081: 'WRBSR2',
    0xc082: 'OFFBSR2',
    0xc083: 'RWBSR2',
    0xc084: 'RDBSR2',
    0xc085: 'WRBSR2',
    0xc086: 'OFFBSR2',
    0xc087: 'RWBSR2',
    0xc088: 'RDBSR1',
    0xc089: 'WRBSR1',
    0xc08a: 'OFFBSR1',
    0xc08b: 'RWBSR1',
    0xc08c: 'RDBSR1',
    0xc08d: 'WRBSR1',
    0xc08e: 'OFFBSR1',
    0xc08f: 'RWBSR1',
    0xd000: 'TOKEN.ADDRESS.TABLE',
    0xd080: 'UNFNC',
    0xd0b2: 'MATHTBL',
    0xd0c7: 'M.NEG',
    0xd0ca: 'M.EQU',
    0xd0cd: 'M.REL',
    0xd0d0: 'TOKEN.NAME.TABLE',
    0xd260: 'ERROR.MESSAGES',
    0xd350: 'QT.ERROR',
    0xd358: 'QT.IN',
    0xd35d: 'QT.BREAK',
    0xd365: 'GTFORPNT',
    0xd393: 'BLTU',
    0xd39a: 'BLTU2',
    0xd3d6: 'CHKMEM',
    0xd3e3: 'REASON',
    0xd410: 'MEMERR',
    0xd412: 'ERROR',
    0xd431: 'PRINT.ERROR.LINNUM',
    0xd43c: 'RESTART',
    0xd45c: 'NUMBERED.LINE',
    0xd4b5: 'PUT.NEW.LINE',
    0xd4f2: 'FIX.LINKS',
    0xd52c: 'INLIN',
    0xd52e: 'INLIN2',
    0xd553: 'INCHR',
    0xd559: 'PARSE.INPUT.LINE',
    0xd56c: 'PARSE',
    0xd61a: 'FNDLIN',
    0xd61e: 'FL1',
    0xd648: 'RTS.1',
    0xd649: 'NEW',
    0xd64b: 'SCRTCH',
    0xd665: 'SETPTRS',
    0xd66a: 'CLEAR',
    0xd66c: 'CLEARC',
    0xd683: 'STKINI',
    0xd696: 'RTS.2',
    0xd697: 'STXTPT',
    0xd6a5: 'LIST',
    0xd6da: 'LIST.0',
    0xd6fe: 'LIST.1',
    0xd702: 'LIST.2',
    0xd724: 'LIST.3',
    0xd72c: 'GETCHR',
    0xd734: 'LIST.4',
    0xd766: 'FOR',
    0xd7af: 'STEP',
    0xd7d2: 'NEWSTT',
    0xd805: 'TRACE.',
    0xd826: 'GOEND',
    0xd828: 'EXECUTE.STATEMENT',
    0xd82a: 'EXECUTE.STATEMENT.1',
    0xd842: 'COLON.',
    0xd846: 'SYNERR.1',
    0xd849: 'RESTORE',
    0xd853: 'SETDA',
    0xd857: 'RTS.3',
    0xd858: 'ISCNTC',
    0xd863: 'CONTROL.C.TYPED',
    0xd86e: 'STOP',
    0xd870: 'END',
    0xd871: 'END2',
    0xd88a: 'END4',
    0xd896: 'CONT',
    0xd8af: 'RTS.4',
    0xd8b0: 'SAVE',
    0xd8c9: 'LOAD',
    0xd8f0: 'VARTIO',
    0xd901: 'PROGIO',
    0xd912: 'RUN',
    0xd921: 'GOSUB',
    0xd935: 'GO.TO.LINE',
    0xd93e: 'GOTO',
    0xd96a: 'RTS.5',
    0xd96b: 'POP',
    0xd97c: 'UNDERR',
    0xd981: 'SYNERR.2',
    0xd984: 'RETURN',
    0xd995: 'DATA',
    0xd998: 'ADDON',
    0xd9a2: 'RTS.6',
    0xd9a3: 'DATAN',
    0xd9a6: 'REMN',
    0xd9c5: 'PULL3',
    0xd9c9: 'IF',
    0xd9dc: 'REM',
    0xd9e1: 'IF.TRUE',
    0xd9ec: 'ONGOTO',
    0xd9f4: 'ON.1',
    0xd9f8: 'ON.2',
    0xda0b: 'RTS.7',
    0xda0c: 'LINGET',
    0xda46: 'LET',
    0xda63: 'LET2',
    0xda7a: 'LET.STRING',
    0xda7b: 'PUTSTR',
    0xdacf: 'PR.STRING',
    0xdad5: 'PRINT',
    0xdad7: 'PRINT2',
    0xdafb: 'CRDO',
    0xdb00: 'NEGATE',
    0xdb02: 'RTS.8',
    0xdb03: 'PR.COMMA',
    0xdb16: 'PR.TAB.OR.SPC',
    0xdb2c: 'NXSPC',
    0xdb2f: 'PR.NEXT.CHAR',
    0xdb35: 'DOSPC',
    0xdb3a: 'STROUT',
    0xdb3d: 'STRPRT',
    0xdb57: 'OUTSP',
    0xdb5a: 'OUTQUES',
    0xdb5c: 'OUTDO',
    0xdb71: 'INPUTERR',
    0xdb7b: 'READERR',
    0xdb7f: 'ERLIN',
    0xdb86: 'INPERR',
    0xdb87: 'RESPERR',
    0xdba0: 'GET',
    0xdbb2: 'INPUT',
    0xdbdc: 'NXIN',
    0xdbe2: 'READ',
    0xdbe9: 'INPUT.FLAG.ZERO',
    0xdbeb: 'PROCESS.INPUT.LIST',
    0xdbf1: 'PROCESS.INPUT.ITEM',
    0xdc2b: 'INSTART',
    0xdc69: 'INPUT.DATA',
    0xdc72: 'INPUT.MORE',
    0xdc99: 'INPFIN',
    0xdca0: 'FINDATA',
    0xdcc6: 'INPDONE',
    0xdcdf: 'ERR.EXTRA',
    0xdcef: 'ERR.REENTRY',
    0xdcf9: 'NEXT',
    0xdcff: 'NEXT.1',
    0xdd02: 'NEXT.2',
    0xdd0d: 'GERR',
    0xdd0f: 'NEXT.3',
    0xdd67: 'FRMNUM',
    0xdd6a: 'CHKNUM',
    0xdd6c: 'CHKSTR',
    0xdd6d: 'CHKVAL',
    0xdd78: 'JERROR',
    0xdd7b: 'FRMEVL',
    0xdd86: 'FRMEVL.1',
    0xdd95: 'FRMEVL.2',
    0xddcd: 'FRM.PRECEDENCE.TEST',
    0xddd6: 'NXOP',
    0xddd7: 'SAVOP',
    0xdde4: 'FRM.RELATIONAL',
    0xddf6: 'PREFNC',
    0xddfd: 'FRM.RECURSE',
    0xde0d: 'SNTXERR',
    0xde10: 'FRM.STACK.1',
    0xde15: 'FRM.STACK.2',
    0xde20: 'FRM.STACK.3',
    0xde35: 'NOTMATH',
    0xde38: 'GOEX',
    0xde3a: 'FRM.PERFORM.1',
    0xde43: 'FRM.PERFORM.2',
    0xde5d: 'EXIT',
    0xde60: 'FRM.ELEMENT',
    0xde81: 'STRTXT',
    0xde90: 'NOT.',
    0xde98: 'EQUOP',
    0xdea4: 'FN.',
    0xdeab: 'SGN.',
    0xdeb2: 'PARCHK',
    0xdeb8: 'CHKCLS',
    0xdebb: 'CHKOPN',
    0xdebe: 'CHKCOM',
    0xdec0: 'SYNCHR',
    0xdec9: 'SYNERR',
    0xdece: 'MIN',
    0xded0: 'EQUL',
    0xded5: 'FRM.VARIABLE',
    0xded7: 'FRM.VARIABLE.CALL',
    0xdef9: 'SCREEN',
    0xdf0c: 'UNARY',
    0xdf4f: 'OR',
    0xdf55: 'AND',
    0xdf5d: 'FALSE',
    0xdf60: 'TRUE',
    0xdf65: 'RELOPS',
    0xdf7d: 'STRCMP',
    0xdfaa: 'STRCMP.1',
    0xdfb0: 'NUMCMP',
    0xdfb5: 'STRCMP.2',
    0xdfc1: 'CMPDONE',
    0xdfcd: 'PDL',
    0xdfd6: 'NXDIM',
    0xdfd9: 'DIM',
    0xdfe3: 'PTRGET',
    0xdfe8: 'PTRGET2',
    0xdfea: 'PTRGET3',
    0xdff4: 'BADNAM',
    0xdff7: 'NAMOK',
    0xe007: 'PTRGET4',
    0xe07d: 'ISLETC',
    0xe087: 'NAME.NOT.FOUND',
    0xe09a: 'C.ZERO',
    0xe09c: 'MAKE.NEW.VARIABLE',
    0xe0de: 'SET.VARPNT.AND.YA',
    0xe0ed: 'GETARY',
    0xe0ef: 'GETARY2',
    0xe0fe: 'NEG32768',
    0xe102: 'MAKINT',
    0xe108: 'MKINT',
    0xe10c: 'AYINT',
    0xe119: 'MI1',
    0xe11b: 'MI2',
    0xe11e: 'ARRAY',
    0xe196: 'SUBERR',
    0xe199: 'IQERR',
    0xe19b: 'JER',
    0xe19e: 'USE.OLD.ARRAY',
    0xe1b8: 'MAKE.NEW.ARRAY',
    0xe24b: 'FIND.ARRAY.ELEMENT',
    0xe253: 'FAE.1',
    0xe269: 'GSE',
    0xe26c: 'GME',
    0xe26f: 'FAE.2',
    0xe270: 'FAE.3',
    0xe2ac: 'RTS.9',
    0xe2ad: 'MULTIPLY.SUBSCRIPT',
    0xe2b6: 'MULTIPLY.SUBS.1',
    0xe2de: 'FRE',
    0xe2f2: 'GIVAYF',
    0xe2ff: 'POS',
    0xe301: 'SNGFLT',
    0xe306: 'ERRDIR',
    0xe30e: 'UNDFNC',
    0xe313: 'DEF',
    0xe341: 'FNC.',
    0xe354: 'FUNCT',
    0xe3af: 'FNCDATA',
    0xe3c5: 'STR',
    0xe3d5: 'STRINI',
    0xe3dd: 'STRSPA',
    0xe3e7: 'STRLIT',
    0xe3ed: 'STRLT2',
    0xe42a: 'PUTNEW',
    0xe432: 'JERR',
    0xe435: 'PUTEMP',
    0xe452: 'GETSPA',
    0xe484: 'GARBAG',
    0xe488: 'FIND.HIGHEST.STRING',
    0xe519: 'CHECK.SIMPLE.VARIABLE',
    0xe523: 'CHECK.VARIABLE',
    0xe552: 'CHECK.BUMP',
    0xe55d: 'CHECK.EXIT',
    0xe562: 'MOVE.HIGHEST.STRING.TO.TOP',
    0xe597: 'CAT',
    0xe5d4: 'MOVINS',
    0xe5e2: 'MOVSTR',
    0xe5e6: 'MOVSTR.1',
    0xe5fd: 'FRESTR',
    0xe600: 'FREFAC',
    0xe604: 'FRETMP',
    0xe635: 'FRETMS',
    0xe646: 'CHRSTR',
    0xe65a: 'LEFTSTR',
    0xe660: 'SUBSTRING.1',
    0xe667: 'SUBSTRING.2',
    0xe668: 'SUBSTRING.3',
    0xe686: 'RIGHTSTR',
    0xe691: 'MIDSTR',
    0xe6b9: 'SUBSTRING.SETUP',
    0xe6d6: 'LEN',
    0xe6dc: 'GETSTR',
    0xe6e5: 'ASC',
    0xe6f2: 'GOIQ',
    0xe6f5: 'GTBYTC',
    0xe6f8: 'GETBYT',
    0xe6fb: 'CONINT',
    0xe707: 'VAL',
    0xe73d: 'POINT',
    0xe746: 'GTNUM',
    0xe74c: 'COMBYTE',
    0xe752: 'GETADR',
    0xe764: 'PEEK',
    0xe77b: 'POKE',
    0xe784: 'WAIT',
    0xe79f: 'RTS.10',
    0xe7a0: 'FADDH',
    0xe7a7: 'FSUB',
    0xe7aa: 'FSUBT',
    0xe7b9: 'FADD.1',
    0xe7be: 'FADD',
    0xe7c1: 'FADDT',
    0xe7ce: 'FADD.2',
    0xe7fa: 'FADD.3',
    0xe829: 'NORMALIZE.FAC.1',
    0xe82e: 'NORMALIZE.FAC.2',
    0xe84e: 'ZERO.FAC',
    0xe850: 'STA.IN.FAC.SIGN.AND.EXP',
    0xe852: 'STA.IN.FAC.SIGN',
    0xe855: 'FADD.4',
    0xe874: 'NORMALIZE.FAC.3',
    0xe880: 'NORMALIZE.FAC.4',
    0xe88d: 'NORMALIZE.FAC.5',
    0xe88f: 'NORMALIZE.FAC.6',
    0xe89d: 'RTS.11',
    0xe89e: 'COMPLEMENT.FAC',
    0xe8a4: 'COMPLEMENT.FAC.MANTISSA',
    0xe8c6: 'INCREMENT.FAC.MANTISSA',
    0xe8d4: 'RTS.12',
    0xe8d5: 'OVERFLOW',
    0xe8da: 'SHIFT.RIGHT.1',
    0xe8dc: 'SHIFT.RIGHT.2',
    0xe8f0: 'SHIFT.RIGHT',
    0xe8fd: 'L',
    // 0xE8FD: 'SHIFT.RIGHT.3',
    0xe907: 'SHIFT.RIGHT.4',
    0xe911: 'SHIFT.RIGHT.5',
    0xe913: 'CON.ONE',
    0xe918: 'POLY.LOG',
    0xe92d: 'CON.SQR.HALF',
    0xe932: 'CON.SQR.TWO',
    0xe937: 'CON.NEG.HALF',
    0xe93c: 'CON.LOG.TWO',
    0xe941: 'LOG',
    0xe948: 'GIQ',
    0xe94b: 'LOG.2',
    0xe97f: 'FMULT',
    0xe982: 'FMULTT',
    0xe9b0: 'MULTIPLY.1',
    0xe9b5: 'MULTIPLY.2',
    0xe9e2: 'RTS.13',
    0xe9e3: 'LOAD.ARG.FROM.YA',
    0xea0e: 'ADD.EXPONENTS',
    0xea10: 'ADD.EXPONENTS.1',
    0xea2b: 'OUTOFRNG',
    0xea31: 'ZERO',
    0xea36: 'JOV',
    0xea39: 'MUL10',
    0xea50: 'CON.TEN',
    0xea55: 'DIV10',
    0xea5e: 'DIV',
    0xea66: 'FDIV',
    0xea69: 'FDIVT',
    0xeae6: 'COPY.RESULT.INTO.FAC',
    0xeaf9: 'LOAD.FAC.FROM.YA',
    0xeb1e: 'STORE.FAC.IN.TEMP2.ROUNDED',
    0xeb21: 'STORE.FAC.IN.TEMP1.ROUNDED',
    0xeb27: 'SETFOR',
    0xeb2b: 'STORE.FAC.AT.YX.ROUNDED',
    0xeb53: 'COPY.ARG.TO.FAC',
    0xeb55: 'MFA',
    0xeb63: 'COPY.FAC.TO.ARG.ROUNDED',
    0xeb66: 'MAF',
    0xeb71: 'RTS.14',
    0xeb72: 'ROUND.FAC',
    0xeb7a: 'INCREMENT.MANTISSA',
    0xeb82: 'SIGN',
    0xeb86: 'SIGN1',
    0xeb88: 'SIGN2',
    0xeb8f: 'RTS.15',
    0xeb90: 'SGN',
    0xeb93: 'FLOAT',
    0xeb9b: 'FLOAT.1',
    0xeba0: 'FLOAT.2',
    0xebaf: 'ABS',
    0xebb2: 'FCOMP',
    0xebb4: 'FCOMP2',
    0xebf2: 'QINT',
    0xec11: 'RTS.16',
    0xec12: 'QINT.2',
    0xec23: 'INT',
    0xec40: 'QINT.3',
    0xec49: 'RTS.17',
    0xec4a: 'FIN',
    0xec61: 'FIN.1',
    0xec64: 'FIN.2',
    0xec66: 'FIN.3',
    0xec87: 'FIN.4',
    0xec8a: 'FIN.5',
    0xec8c: 'FIN.6',
    0xec98: 'FIN.10',
    0xec9e: 'FIN.7',
    0xeca0: 'FIN.8',
    0xecc1: 'FIN.9',
    0xecd5: 'ADDACC',
    0xece8: 'GETEXP',
    0xed0a: 'CON.99999999.9',
    0xed0f: 'CON.999999999',
    0xed14: 'CON.BILLION',
    0xed19: 'INPRT',
    0xed24: 'LINPRT',
    0xed2e: 'PRINT.FAC',
    0xed31: 'GO.STROUT',
    0xed34: 'FOUT',
    0xed36: 'FOUT.1',
    0xed8c: 'FOUT.2',
    0xee17: 'FOUT.3',
    0xee57: 'FOUT.4',
    0xee5a: 'FOUT.5',
    0xee5f: 'FOUT.6',
    0xee64: 'CON.HALF',
    0xee69: 'DECTBL',
    // 0xEE8D: 'DECTBL.END',
    0xee8d: 'SQR',
    0xee97: 'FPWRT',
    0xeed0: 'NEGOP',
    0xeeda: 'RTS.18',
    0xeedb: 'CON.LOG.E',
    0xeee0: 'POLY.EXP',
    0xef09: 'EXP',
    0xef5c: 'POLYNOMIAL.ODD',
    0xef72: 'POLYNOMIAL',
    0xef76: 'SERMAIN',
    0xefa5: 'RTS.19',
    0xefa6: 'CON.RND.1',
    0xefaa: 'CON.RND.2',
    0xefae: 'RND',
    0xefe7: 'GO.MOVMF',
    0xefea: 'COS',
    0xeff1: 'SIN',
    0xf023: 'SIN.1',
    0xf026: 'SIN.2',
    0xf03a: 'TAN',
    0xf062: 'TAN.1',
    0xf066: 'CON.PI.HALF',
    0xf06b: 'CON.PI.DOUB',
    0xf070: 'QUARTER',
    0xf075: 'POLY.SIN',
    0xf09e: 'ATN',
    0xf0cd: 'RTS.20',
    0xf0ce: 'POLY.ATN',
    0xf10b: 'GENERIC.CHRGET',
    0xf128: 'COLD.START',
    // 0xF128: 'GENERIC.END',
    0xf1d5: 'CALL',
    0xf1de: 'IN.NUMBER',
    0xf1e5: 'PR.NUMBER',
    0xf1ec: 'PLOTFNS',
    0xf206: 'GOERR',
    0xf209: 'LINCOOR',
    0xf225: 'PLOT',
    0xf232: 'HLIN',
    0xf241: 'VLIN',
    0xf24f: 'COLOR',
    0xf256: 'VTAB',
    0xf262: 'SPEED',
    0xf26d: 'TRACE',
    0xf26f: 'NOTRACE',
    0xf273: 'NORMAL',
    0xf277: 'INVERSE',
    0xf279: 'N.I.',
    0xf27b: 'N.I.F.',
    0xf280: 'FLASH',
    0xf286: 'HIMEM',
    0xf296: 'JMM',
    0xf299: 'SETHI',
    0xf2a6: 'LOMEM',
    0xf2cb: 'ONERR',
    0xf2e9: 'HANDLERR',
    0xf318: 'RESUME',
    0xf32e: 'JSYN',
    0xf331: 'DEL',
    0xf390: 'GR',
    0xf399: 'TEXT',
    0xf39f: 'STORE',
    0xf3bc: 'RECALL',
    0xf3d8: 'HGR2',
    0xf3e2: 'HGR',
    0xf3ea: 'SETHPG',
    0xf3f2: 'HCLR',
    0xf3f6: 'BKGND',
    0xf411: 'HPOSN',
    0xf457: 'HPLOT0',
    0xf465: 'MOVE.LEFT.OR.RIGHT',
    0xf46e: 'LR.1',
    0xf471: 'LR.2',
    0xf476: 'LR.3',
    0xf478: 'LR.4',
    0xf47e: 'COLOR.SHIFT',
    0xf48a: 'MOVE.RIGHT',
    0xf49c: 'LRUDX1',
    0xf49d: 'LRUDX2',
    0xf4b3: 'LRUD1',
    0xf4b4: 'LRUD2',
    0xf4c4: 'LRUD3',
    0xf4c8: 'LRUD4',
    0xf4cd: 'CON.03',
    0xf4d3: 'MOVE.UP.OR.DOWN',
    0xf501: 'UD.1',
    0xf505: 'MOVE.DOWN',
    0xf508: 'CON.04',
    0xf530: 'HLINRL',
    0xf53a: 'HGLIN',
    0xf57c: 'MOVEX',
    0xf581: 'MOVEX2',
    0xf5b2: 'MSKTBL',
    0xf5b9: 'CON.1C',
    0xf5ba: 'COSINE.TABLE',
    0xf5cb: 'HFIND',
    0xf600: 'RTS.22',
    0xf601: 'DRAW0',
    0xf605: 'DRAW1',
    0xf65d: 'XDRAW0',
    0xf661: 'XDRAW1',
    0xf6b9: 'HFNS',
    0xf6e6: 'GGERR',
    0xf6e9: 'HCOLOR',
    0xf6f5: 'RTS.23',
    0xf6f6: 'COLORTBL',
    0xf6fe: 'HPLOT',
    0xf721: 'ROT',
    0xf727: 'SCALE',
    0xf72d: 'DRWPNT',
    0xf769: 'DRAW',
    0xf76f: 'XDRAW',
    0xf775: 'SHLOAD',
    0xf7bc: 'TAPEPNT',
    0xf7d9: 'GETARYPT',
    0xf7e7: 'HTAB',
    0xf800: 'MON.PLOT',
    0xf819: 'MON.HLINE',
    0xf828: 'MON.VLINE',
    0xf864: 'MON.SETCOL',
    0xf871: 'MON.SCRN',
    0xfb1e: 'MON.PREAD',
    0xfb39: 'MON.SETTXT',
    0xfb40: 'MON.SETGR',
    0xfb5b: 'MON.TABV',
    0xfc58: 'MON.HOME',
    0xfca8: 'MON.WAIT',
    0xfcfa: 'MON.RD2BIT',
    0xfd0c: 'MON.RDKEY',
    0xfd6a: 'MON.GETLN',
    0xfded: 'MON.COUT',
    0xfe8b: 'MON.INPORT',
    0xfe95: 'MON.OUTPORT',
    0xfecd: 'MON.WRITE',
    0xfefd: 'MON.READ',
    0xff02: 'MON.READ2',
};

export default SYMBOLS;
